<template>
  <div>
    <print-temp />
  </div>
</template>

<script>
import printTemp from './PrintTemp.vue'
import storage from '@/utils/storagehandle'

export default {
  name: 'warehouseIntoPrinttemp',
  components: {
    printTemp
  },
  destroyed () {
    storage.removeItem('taskPrintBillIntoGoodList')
    storage.removeItem('taskPrintBillIntoGoodsTotalPiece')
    storage.removeItem('taskPrintBillIntoGoodsSku')
  }
}
</script>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouseIntoPrinttemp.vue